/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Typography, ListItem, SvgIcon, Button, } from "@material-ui/core";
import { InsertDriveFileOutlined } from "@material-ui/icons";
import { FormattedMessage } from "react-intl";

import { styles } from "../constants/styles";
import { docItem } from "../constants/types";

type OwnProps = {
    item: docItem;
    download: (item: docItem) => void
}

type Props = OwnProps & WithStyles<typeof styles>;

const DocsList: React.FC<Props> = (props: Props) => {
const [visited, setVisited] = React.useState<boolean>(false)

const {classes, item, download} = props;

const handleClick = (item) => () => {
  download(item)
  setVisited(true)
}

return (
    <ListItem key={item.id} className={classes.docItem}>
    <div className={classes.cardContent}>
      <div>
        <SvgIcon className={classes.iconContainer} fontSize={"small"}>
          <InsertDriveFileOutlined />
        </SvgIcon>
      </div>
      <div>
        <Button className={visited? classes.downloadButtonVisited : classes.downloadButton} disableRipple onClick={handleClick(item)}>
          <FormattedMessage {...item.name} />
        </Button>
        {item.description ? (
          <Typography className={classes.docItemText}>
            <FormattedMessage {...item.description} />
          </Typography>
        ) : null}
      </div>
    </div>
  </ListItem>
)
}

export default withStyles(styles)(DocsList);

